import { Fragment } from 'react';
import { UrlObject } from 'url';
import classNames from 'classnames';

import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';
import { FormattedMessage } from 'utils/intl';

import FilterButton from '../FilterButton';
import FilterLink from '../FilterLink';
import classes from './FilterBar.module.scss';
import messages from './FilterBar.messages';

export type Props = {
  size?: 'small' | 'medium';
  filterTags: { searchKey: string; values: string[]; label: string }[];
  filterClearHref: UrlObject;
  getFilterClearHref: (value: string[], key: string) => UrlObject;
};

const FilterBar = ({ size = 'medium', filterTags, filterClearHref, getFilterClearHref }: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, classes[size])}>
    {filterTags.length > 0 && (
      <>
        {filterTags.map(({ searchKey, values, label }) => (
          <Fragment key={searchKey}>
            <div className={classes.valuesWrapper} data-eid="filter-chip">
              <Typography variant="body2" renderAs="span" className={classes.label}>
                {label}
              </Typography>
              {values.map((value) => {
                const href = getFilterClearHref([value], searchKey);

                return (
                  <Fragment key={`${searchKey}-${value}`}>
                    <FilterButton>
                      <Link component={href?.query ? 'span' : undefined} href={href} className={classes.link}>
                        <Typography variant="body2" weight="700" renderAs="span">
                          <FilterLink label={value} />
                        </Typography>
                      </Link>
                    </FilterButton>
                    <div className={classes.spacerVertical} />
                  </Fragment>
                );
              })}
            </div>
          </Fragment>
        ))}
        {size === 'medium' && (
          <Link
            className={classes.clearLink}
            component={filterClearHref?.query ? 'span' : undefined}
            href={filterClearHref}
            data-eid="clear-filters"
          >
            <FilterButton variant="clear">
              <FormattedMessage values={{ length: filterTags.length }} {...messages.clear} />
            </FilterButton>
          </Link>
        )}
        <div className={classNames(classes.spacerHorizontal, classes.spacerVertical)} />
      </>
    )}
  </div>
);

export default FilterBar;
